import { render } from "./ExpanderVideo.vue?vue&type=template&id=5345f0d9&scoped=true"
import script from "./ExpanderVideo.vue?vue&type=script&lang=js"
export * from "./ExpanderVideo.vue?vue&type=script&lang=js"

import "./ExpanderVideo.vue?vue&type=style&index=0&id=5345f0d9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5345f0d9"]])

export default __exports__